module.exports = __webpack_public_path__ + "static/big-save-56b9abec895763103b7eb1cd3a6d6e5d.jpg";